export const types = {
    CLEAR_ALL_RECIPES: '[RECIPES] clear_all_recipes',
};

export const clearAllRecipes = () => ({
    type: types.CLEAR_ALL_RECIPES,
});
